import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

export const userService = {
  signup: async (userData: {
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    img_url: string | null;
    role: string;
    org_id: string;
  }) => {
    const token = localStorage.getItem("token");
    
    const response = await axios.post(`${API_BASE_URL}/auth/signup`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  login: async (email: string, password: string) => {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, {
      email,
      password,
    });
    return response.data;
  },

  getProfile: async () => {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API_BASE_URL}/auth/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  getUsers: async (params?: {
    orgId?: string;
    page?: number;
    limit?: number;
  }) => {
    const token = localStorage.getItem("token");

    // query parameters
    const query = new URLSearchParams();

    if (params?.orgId) query.append("orgId", params.orgId);
    if (params?.page) query.append("page", params.page.toString());
    if (params?.limit) query.append("limit", params.limit.toString());

    const response = await axios.get(
      `${API_BASE_URL}/auth/users?${query.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  },

  updateUser: async (
    id: string,
    data: {
      first_name?: string;
      last_name?: string;
      password?: string;
      email?: string;
      role?: string;
      img_url?: string;
    }
  ) => {
    const token = localStorage.getItem("token");

    const response = await axios.put(
      `${API_BASE_URL}/auth/update/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },

  deleteUser: async (id: string) => {
    const token = localStorage.getItem("token");

    const response = await axios.delete(`${API_BASE_URL}/auth/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};
